export const mainLayoutStyles = {
  px: { xs: 1, md: 2 },
  flexGrow: {
    xs: 0,
    md: 1,
  },
  width: '100%',
  height: '100%',
  overflow: 'auto',
};
